export const Home = '/home';

export const Access = {
  Request: `/access/requests/:objectId`,
};

export const Workspaces = {
  Brand: `/workspaces/brands/:brandId`,
  BrandNotFound: `/workspaces/brands/not-found`,
  BrandTabs: `/workspaces/brands/:brandId/:tab`,
  FileNotFound: `/workspaces/files/not-found`,
  FolderNotFound: `/workspaces/folders/not-found`,
};

export const WorkspaceBrandTabs = {
  ProjectTracker: `/workspaces/brands/:brandId/tracker`,
  Projects: `/workspaces/brands/:brandId/projects`,
  Files: `/workspaces/brands/:brandId/files`,
};

export const Brands = {
  Root: `/brands`,
};

export const Projects = {
  Root: `/projects`,
  Create: `/projects/create`,
};